module.exports = __webpack_public_path__ + "static/media/sc8r_11.dcbb9bf2.png";